import React from 'react';

import {
  useFieldArray,
  useForm
} from 'react-hook-form';
import {
  Button,
  Grid,
  Stack
} from '@mui/material';
import {
  fields,
  Form,
  formUtil
} from 'iron-forge-react-modules';

import { appFormUtil } from 'modules/layer00';
import { BaseWidget } from 'modules/layer01';
import * as dataService from './dataService';
import * as types from './types';



const ControlledTextField = fields.TextField.genControllerComponent<types.IFormState>();
const ControlledCheckBox = fields.CheckboxField.genControllerComponent<types.IFormState>();



export interface IProps {
  storeId: string;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery(props.storeId);
  const [saveStoreEmailSettings, saveStoreEmailSettingsTuple] = dataService.useSaveStoreEmailSettings(props.storeId);

  const form = useForm<types.IFormState>({
    defaultValues: {
      fromEmail: '',
      fromName: '',
      emailSettings: []
    }
  });

  const fieldArray = useFieldArray({
    control: form.control,
    name: 'emailSettings'
  });

  formUtil.useSetFormFields(queryTuple, form.setValue, ['emailSettings', 'fromEmail', 'fromName']);



  const processSubmit = React.useCallback(
    (formState: types.IFormState) => {
      saveStoreEmailSettings(appFormUtil.trimFormStateValues(formState));
    },
    [saveStoreEmailSettings]
  );



  const loading = queryTuple.loading || saveStoreEmailSettingsTuple.loading;

  return (
    <Form.FC
      disableDefaultOverflow
      onSubmit={form.handleSubmit(processSubmit)}>
      <BaseWidget.FC
        title="Email Settings"
        elAction={
          <Button
            disabled={loading}
            variant="contained"
            type="submit">
            Save
          </Button>
        }>
        <Grid
          container
          columnSpacing={1}
          rowSpacing={2}
          alignItems="center">
          <Grid
            item
            xs={12}>
            <Stack
              direction="row"
              spacing={1}
              justifyContent="stretch">
              <ControlledTextField
                isDisabled={loading}
                label="From Name"
                fieldKey="fromName"
                formControl={form.control} />

              <ControlledTextField
                isDisabled={loading}
                label="From Email"
                fieldKey="fromEmail"
                type="email"
                formControl={form.control} />
            </Stack>
          </Grid>

          {fieldArray.fields.map((field, index) => (
            <React.Fragment key={index}>
              <Grid
                item
                xs={6}>
                {queryTuple.data.appEventName2DisplayName[field.appEvent]}
              </Grid>

              <Grid
                item
                xs={4}>
                {/* Controlled text field */}
                <ControlledTextField
                  isDisabled={loading}
                  fieldKey={`emailSettings.${index}.templateId`}
                  label="Template ID"
                  size="small"
                  formControl={form.control}
                  disableDefaultMargins />
              </Grid>

              <Grid
                item
                xs={2}>
                <ControlledCheckBox
                  isDisabled={loading}
                  fieldKey={`emailSettings.${index}.isActive`}
                  label="Active?"
                  formControl={form.control} />
              </Grid>
            </React.Fragment>
          ))}
        </Grid>
      </BaseWidget.FC>
    </Form.FC>
  );
};
